<div class="container">
    <section class="section_1">
        <div class="table">
            <div class="table_info">
                <table>
                    <thead>
                        <tr>
                            <th *ngFor="let column of tableColumns">
                                {{ column }}
                            </th>
                        </tr>
                    </thead>
                    <tbody *ngIf="statistic">
                        <tr>
                            <td>{{ statistic?.gameCode }}</td>
                            <td>{{ statistic?.theo_rtp }}</td>
                            <td>{{ statistic?.act_rtp }}</td>
                            <td>{{ statistic?.client_game_active }}</td>
                            <td>
                                {{
                                    statistic?.start_time
                                        | date: 'dd/MM/YYYY HH:mm:ss'
                                }}
                            </td>
                            <td>{{ statistic?.games_played }}</td>
                            <td>{{ statistic?.payin | roundNumber }}</td>
                            <td>{{ statistic?.payout | roundNumber }}</td>
                            <td>{{ statistic?.revenue | roundNumber }}</td>
                            <td>
                                {{
                                    statistic?.date_decom
                                        | date: 'dd/MM/YYYY HH:mm:ss'
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="refresh_data">
                <button
                    mat-raised-button
                    color="primary"
                    class="btn-refresh"
                    (click)="onClick()"
                >
                    Refresh data
                </button>
            </div>
        </div>
    </section>
    <section class="section_2">
        <h2>Number of Paylines: {{ this.countReelPosition }}</h2>
        <!-- <p>Reel positions 2-5-8-11</p> -->
        <div class="scroll-container">
            <div class="image-container">
                <div *ngFor="let image of reelPosition; let i = index">
                    <span>{{ i + 1 }}</span>
                    <div>
                        <img
                            [src]="image.path"
                            alt=""
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section_3">
        <div class="container_img">
            <div class="small_img">
                <h4>Symbols :</h4>
                <div
                    class="flex_item"
                    *ngFor="let image of GotnSimbolImg"
                >
                    <img
                        [src]="image.path"
                        alt=""
                    />
                    <span>{{ image.text }}</span>
                </div>
            </div>
            <div class="big_img">
                <div
                    class="flex_item"
                    *ngFor="let image of GotnPaylinesImg"
                >
                    <div>
                        <img
                            [src]="image.path"
                            alt=""
                        />
                    </div>
                    <div>
                        <!-- <span>{{image.text}}</span> -->
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
